export const SET_MENU_CATEGORIES = 'SET_MENU_CATEGORIES'
export const SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES'
export const SET_STATS_DATA = 'SET_STATS_DATA'
